import { trackCourseClick } from "../api/productsApi";

/**
 * Track a course click without owning component state or navigation.
 * Navigation is handled by the Link in CourseSearchResults.
 */
const handleCourseClick = async (course) => {
  if (!course?._id) {
    return;
  }

  try {
    await trackCourseClick(course._id);
  } catch (error) {
    console.warn("Failed to track course click:", error);
  }
};

export default handleCourseClick;
